import React, { Fragment } from "react"
import { Table } from "semantic-ui-react"
import Price from "components/Price/Price";
import shop from "shop/shop"

const PositionRow = ({ position, product }) => {
  const useProductData = product && product.extras
  return (
    <tr>
      <td>{position.article_nr}</td>
      <td><span className="f5">{position.desc}</span></td>
      <td className="tl">{position.count * position.unit_multi} {translate("Stück")} <br />
        {/*<div className="black-60 d6 ">{position.count * position.unit_multi} {translate( "piece" )}</div>*/}
      </td>
      <td className="tr"><Price>{position.price * position.unit_multi}</Price></td>
      <td className="tr">
        <div className="tr"><Price>{position.sum}</Price></div>
      </td>
    </tr>
  )
}

const SuccessTable = ({ positions, netto, byId, append = null, prepend = null }) => {
  const tax = Number(netto) / 100 * Number(shop.config.taxRate)
  const hasTax = shop.config.taxRate
  return (
    <Table>
      <colgroup>
        <col width="10%" />
        <col width="45%" />
        <col width="15%" />
        <col width="15%" />
        <col width="15%" />
      </colgroup>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{translate("article")}</Table.HeaderCell>
          <Table.HeaderCell>&nbsp;</Table.HeaderCell>
          <Table.HeaderCell className="tl">{translate("Anzahl")}</Table.HeaderCell>
          <Table.HeaderCell className="tr">{translate("Preis/VE")}</Table.HeaderCell>
          <Table.HeaderCell className="tr">
            <div className="tr">{translate("Summe")}</div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {prepend && prepend}

        {positions.map((position) => {
          const product = byId[position.article_id]
          return <PositionRow key={position.article_id} position={position} product={product} />
        })}

        <Table.Row>
          <Table.Cell colSpan={4} className=" tr">
            <div className="tr">{translate("Gesamtpreis netto:")}</div>
          </Table.Cell>
          <Table.Cell>
            <div className="pv3 f3 tr "><Price>{netto}</Price></div>
          </Table.Cell>
        </Table.Row>

        {append && append}
        {shop.session && shop.session.value.country === "D" && <Fragment>
          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5  ">{translate("zzgl. Steuern")} ({shop.config.taxRate.replace(".", ",")}%)</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax}</Price></div>
            </Table.Cell>
          </Table.Row>}

          {hasTax && <Table.Row>
            <Table.Cell colSpan={4} className=" tr">
              <div className="tr"><span className="f5 b black">{translate("inkl. Steuern")}</span></div>
            </Table.Cell>
            <Table.Cell>
              <div className="pv3 f3 tr "><Price>{tax + Number(netto)}</Price></div>
            </Table.Cell>
          </Table.Row>}
        </Fragment>}

      </Table.Body>
    </Table>
  )
}

export default SuccessTable


// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/SuccessTable.js